export enum SupportStatus {
  NEW = 'new',
  SOLVED = 'solved',
}
